export default __webpack_public_path__ + "static/27-100-e1d6984d2e5fa0461342ab1053abfe68.jpg";